import {keyBy, difference, keys, omit} from 'helpers';

export function emotionsMeter(state = {}, action) {

  switch (action.type) {
    case 'DIARY_MOOD_CHANGE':
      return {
        ...state,
        [action.mood.id || action.generateId('emotionsMeterId')]: action.mood
      }

    case 'DIARY_DELETE':
      const { mood } = action.select('diary.details', { id: action.id }) || {};
      if (mood) {
        return omit(state, mood.emotionsMeterId);
      }
      return state;

    case 'SERVER_DATA_RECEIVED':
      const removed = difference(keys(state), action.existingElementIds.emotionsMeter);
      if (action.emotionsMeter.length || removed.length) {
        return omit({
          ...state,
          ...keyBy(action.emotionsMeter, 'id'),
        }, removed);
      }
      return state;

    default:
      return state;
  }

}
